module.exports = __webpack_public_path__ + "static/media/stage12.d1d58a9d.svg";